import '../map/style.css';

import { useState } from 'react';
import { Map, APIProvider } from '@vis.gl/react-google-maps';

import { CustomAdvancedMarker } from '../map/components/custom-advanced-marker/custom-advanced-marker';

type ActivitySingleMapProps = {
  activity: any;
};

const ActivitySingleMap = ({ activity }: ActivitySingleMapProps) => {
  const [openMarkerId, setOpenMarkerId] = useState<string | null>(null);

  // Koordinatları güvenli bir şekilde çevir
  const centerLat = Number(activity?.location?.lat) || 41.0082;
  const centerLng = Number(activity?.location?.long) || 28.9784;

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string}>
      <div className="advanced-marker-example" style={{ width: '100%', height: '400px' }}>
        <Map
          mapId={process.env.REACT_APP_GOOGLE_MAPS_ID as string}
          style={{ width: '100%', height: '100%' }}
          defaultCenter={{ 
            lat: centerLat, 
            lng: centerLng 
          }}
          defaultZoom={15}
          gestureHandling="greedy"
          disableDefaultUI
          onClick={() => setOpenMarkerId(null)}
        >
          <CustomAdvancedMarker
            key={activity._id || activity.id}
            activity={activity}
            openMarkerId={openMarkerId}
            setOpenMarkerId={setOpenMarkerId}
          />
        </Map>
      </div>
    </APIProvider>
  );
};

export default ActivitySingleMap; 